import { render, staticRenderFns } from "./ydTopChart.vue?vue&type=template&id=4496c507"
import script from "./ydTopChart.vue?vue&type=script&lang=js"
export * from "./ydTopChart.vue?vue&type=script&lang=js"
import style0 from "./ydTopChart.vue?vue&type=style&index=0&id=4496c507&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports